// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const TransactionSectionsWrapper = styled.div`
	background: #FFFFFF;
	box-shadow: ${colors.box_shadow};
	margin-bottom: 1em;
`;

export default TransactionSectionsWrapper;


// WEBPACK FOOTER //
// ./src/pages/league/transactions/transactionSectionsWrapper.js